module.exports = __webpack_public_path__ + "static/img/top-img.46b5a31.png";